import React from 'react';
import { useTranslation } from 'react-i18next';
import RentalDurationSelector from '~addListing/pages/PriceStep/RentalDurationSelector';
import { ListingDetailsType } from '~addListing/types';

const RentalDuration = ({ listing }: { listing: ListingDetailsType }) => {
  const { t } = useTranslation('app');

  return (
    <div className="flex flex-col gap-1.5x">
      <p className="text-title_4 text-black">{t('rentalDuration')}</p>
      <RentalDurationSelector listing={listing} />
    </div>
  );
};

export default RentalDuration;
